import produce from 'immer';
import type { SharedCartState, SharedCartReducer as TSharedCartReducer } from '@common/Checkout/SharedCart/types';
import {
    SET_SHARED_CART_ERROR,
    SET_IS_LOADED,
    SET_IS_REQUEST_PENDING,
    SET_CART_HASH, SET_SHARED_CART,
} from '../actions/constants';

const initialState: SharedCartState = {
    hash: null,
    isRequestPending: false,
    isLoaded: false,
    error: null,
    cart: null,
};

const SharedCartReducer: TSharedCartReducer = produce((state, action) => {
    const { type, payload } = action;

    if (!state) return;

    switch (type) {
        case SET_SHARED_CART: {
            state.cart = payload;
            break;
        }

        case SET_SHARED_CART_ERROR: {
            state.error = payload;
            break;
        }

        case SET_IS_REQUEST_PENDING: {
            state.isRequestPending = payload;
            break;
        }

        case SET_IS_LOADED: {
            state.isLoaded = payload;
            break;
        }

        case SET_CART_HASH: {
            state.hash = payload;
            break;
        }
        // skip default
    }
}, initialState);

export default SharedCartReducer;
